module.exports = __webpack_public_path__ + "media/apps/gif-ios-7-527e0aaf.gif";